import {Component, DestroyRef, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {
  BokkzVpbDataService,
  CorporateTaxEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormControl, FormGroup} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {debounceTime, filter, Observable, shareReplay, tap} from "rxjs";
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-vragen-fiscale-eenheid',
  templateUrl: './vragen-fiscale-eenheid.component.html',
  styleUrls: ['./vragen-fiscale-eenheid.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    AsyncPipe
  ]
})
export class VragenFiscaleEenheidComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private dataService = inject(BokkzVpbDataService);
  private destroyRef = inject(DestroyRef);
  public isFiscaleEenheid = false;

  readonly corporateTaxEntity$: Observable<CorporateTaxEntity> =
    this.dataService.corporateTaxEntity$.pipe(
      filter((data): data is CorporateTaxEntity => !!data?.sstRelationId),
      tap(data => {
        if (data.aangifte) {
          this.isFiscaleEenheid = data.aangifte.identificatie.aangifteFiscaleEenheid ?? false;
          this.vragenFiscaleEenheidFg.patchValue(data.aangifte?.vragenFiscaleEenheid ?? {}, {emitEvent: false});
        }
      }),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  public vragenFiscaleEenheidFg = new FormGroup({
    voegingMetBestaandeDochtermaatschappijen: new FormControl(false, {nonNullable: true}),
    ontvoegingVanDochtermaatschappijen: new FormControl(false, {nonNullable: true}),
    beeindigingDoorliquidatieDochter: new FormControl(false, {nonNullable: true}),
    verzoekMeegevenVerliezenOntvoegdeDochter: new FormControl(false, {nonNullable: true}),
    verzoekNietVerbrekenJuridischeFusie: new FormControl(false, {nonNullable: true}),
    verzoekMeegevenVerliezenVerkrijger: new FormControl(false, {nonNullable: true}),
    verzoekNietVerbrekenBijVerdwijnendeDochter: new FormControl(false, {nonNullable: true}),
    verzoekMeegevenVerliezenvanVerdwijnendeDochter: new FormControl(false, {nonNullable: true}),
    verzoekMeegevenUitdelingstekort: new FormControl(false, {nonNullable: true}),
  });

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  ngOnInit(): void {
    this.vragenFiscaleEenheidFg.valueChanges.pipe(
      debounceTime(300),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.saveForm();
    });
  }

  ngOnDestroy(): void {
    this.saveForm();
  }

  saveForm(): void {
    this.vragenFiscaleEenheidFg.updateValueAndValidity({emitEvent: false});
    const algemeen = this.vragenFiscaleEenheidFg.getRawValue();

    this.dataService.patchCorporateTaxEntity(currentEntity => {
      if (!currentEntity.aangifte) {
        return currentEntity;
      }

      return {
        ...currentEntity,
        aangifte: {
          ...currentEntity.aangifte,
          vragenFiscaleEenheid: {
            ...currentEntity.aangifte.vragenFiscaleEenheid,
            voegingMetBestaandeDochtermaatschappijen: algemeen.voegingMetBestaandeDochtermaatschappijen ?? false,
            ontvoegingVanDochtermaatschappijen: algemeen.ontvoegingVanDochtermaatschappijen ?? false,
            beeindigingDoorliquidatieDochter: algemeen.beeindigingDoorliquidatieDochter ?? false,
            verzoekMeegevenVerliezenOntvoegdeDochter: algemeen.verzoekMeegevenVerliezenOntvoegdeDochter ?? false,
            verzoekNietVerbrekenJuridischeFusie: algemeen.verzoekNietVerbrekenJuridischeFusie ?? false,
            verzoekMeegevenVerliezenVerkrijger: algemeen.verzoekMeegevenVerliezenVerkrijger ?? false,
            verzoekNietVerbrekenBijVerdwijnendeDochter: algemeen.verzoekNietVerbrekenBijVerdwijnendeDochter ?? false,
            verzoekMeegevenVerliezenvanVerdwijnendeDochter: algemeen.verzoekMeegevenVerliezenvanVerdwijnendeDochter ?? false,
            verzoekMeegevenUitdelingstekort: algemeen.verzoekMeegevenUitdelingstekort ?? false,
          },
        },
      };
    });
  }
}
